import { submitAutoLoanInquiryApplication } from 'app/actions/form/actions';
import { AutoAcknowledgeGapInsurance } from 'app/components/AutoLoan/AutoAcknowledgeGapInsurance';
import { FieldNames } from 'app/models/fields/names';
import { Section } from 'app/models/types';
import { FormParagraphs } from '../paragraphs';
import { autoLoanInquiryQuestionById, autoLoanInquiryQuestionsByName } from '../questions/auto-loan-inquiry';
import {
  AUTO_LOAN_INQUIRY_APP_CHOOSE_VEHICLE,
  AUTO_LOAN_INQUIRY_APP_FINAL,
  AUTO_LOAN_INQUIRY_FINAL_PAGE_QUESTION,
  AUTO_LOAN_INQUIRY_GET_CONTACT_INFORMATION,
  AUTO_LOAN_INQUIRY_GET_LOAN_INFORMATION,
  AUTO_LOAN_INQUIRY_GET_PURCHASE_PLAN,
} from './constants';

export const getAutoLoanInquirySectionById = (id: number): Section => {
  return AUTO_LOAN_INQUIRY_SECTIONS.find((section) => section.id === id) as Section;
};

const AUTO_LOAN_INQUIRY_SECTIONS: Section[] = [
  {
    id              : AUTO_LOAN_INQUIRY_GET_PURCHASE_PLAN,
    questions       : autoLoanInquiryQuestionsByName([FieldNames.autoPurchasePlan]),
    hideBackButton  : true,
    hideProgressBar : true,
    title           : 'How are you planning to purchase the vehicle?',
    paragraph       : FormParagraphs.autoPurchasePlan,
  },
  {
    id       : AUTO_LOAN_INQUIRY_APP_CHOOSE_VEHICLE,
    title    : 'Tell us about the vehicle you are interested in purchasing',
    questions: autoLoanInquiryQuestionsByName([
      FieldNames.vehicleMileage,
      FieldNames.vehicleYear,
      FieldNames.vehicleMake,
      FieldNames.vehicleModel,
    ]),
  },
  {
    id       : AUTO_LOAN_INQUIRY_GET_LOAN_INFORMATION,
    questions: autoLoanInquiryQuestionsByName([
      FieldNames.purchasePrice,
      FieldNames.tradeInValue,
      FieldNames.downDollar,
      FieldNames.loanTermDesired,
    ]),
    agreement: <AutoAcknowledgeGapInsurance />,
  },
  {
    id       : AUTO_LOAN_INQUIRY_GET_CONTACT_INFORMATION,
    title    : 'Enter your personal information',
    questions: autoLoanInquiryQuestionsByName([
      FieldNames.firstName,
      FieldNames.middleName,
      FieldNames.lastName,
      FieldNames.suffixName,
      FieldNames.email,
      FieldNames.phone,
      FieldNames.dateOfBirth,
    ]),
    submitAction: submitAutoLoanInquiryApplication,
    submitText: 'Submit',
  },
  {
    id                : AUTO_LOAN_INQUIRY_APP_FINAL,
    questions         : [autoLoanInquiryQuestionById(AUTO_LOAN_INQUIRY_FINAL_PAGE_QUESTION)],
    hideBackButton    : true,
    hideForwardButton : true,
    hideProgressBar   : true,
  },
];
